const ThemeConfig = {
  token: {
    fontFamily: 'Inter, sans-serif',
    fontSize: 14,
  },
};

export default ThemeConfig;
